import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './styles.module.sass';
import AttachFiles from 'components/common/AttachFiles/index';
import NumberField from 'components/common/NumberField/index';
import TextField from 'components/common/TextField/index';
import Label from 'components/common/Label/index';
import {connect} from 'react-redux';
import {modalShow, modalHide} from 'actions/modal';
import ButtonAttachFile, {AttachFileList} from 'components/common/AttachFile';
import EditIcon from '@material-ui/icons/Edit';
import ButtonIcon from 'components/common/ButtonIcon';
import FormEditText from 'components/common/FormEditText';

function toAttachmentList(attachmentList, files) {
  if (!files) return null;

  const dictAttachmentList = {};
  if (attachmentList) {
    for (let i = 0; i < attachmentList.length; i++) {
      const attachment = attachmentList[i];
      dictAttachmentList[attachment.fileStorageId] = attachment;
    }
  }

  return files.map(a => ({fileName: a.name, fileStorageId: a.id, id: dictAttachmentList[a.id] && dictAttachmentList[a.id].id}));
}

function fromAttachmentList(attachmentList) {
  if (!attachmentList) return null;
  return attachmentList.map(a => ({name: a.fileName, id: a.fileStorageId}));
}

@connect()
class LegalCost extends PureComponent {
  state = {
    fetchingFiles: []
  };

  handlerOnChange = (nextState) => {
    const {onChange} = this.props;

    const {value} = this.props;

    nextState = {...value, ...nextState};
    if (onChange) onChange(nextState);
  };

  handlerAttachFileButtonOnFetching = (fetchingFile) => {
    const {fetchingFiles} = this.state;
    this.setState({fetchingFiles: (fetchingFiles || []).concat(fetchingFile)});
  };

  handlerAttachFileButtonOnFetchingComplete = (fetchingFile) => {
    const {fetchingFiles} = this.state;
    this.setState({fetchingFiles: (fetchingFiles || []).filter(a => a.key !== fetchingFile.key)});
  };

  handlerAttachFileButtonOnChange = (fileObject) => {
    const {value: {attachmentList} = {}} = this.props;
    this.handlerOnChange({attachmentList: (attachmentList || []).concat({fileName: fileObject.name, fileStorageId: fileObject.id})});
  };

  handlerEditOnClick = () => {
    const {dispatch, value: {comment} = {}} = this.props;
    dispatch(modalShow(
      <FormEditText
        title={'Редактирование комментария'}
        defaultText={comment}
        onOk={v => {this.handlerOnChange({comment: v}); dispatch(modalHide());}}
        onCancel={() => dispatch(modalHide())}
      />
    ));
  };

  render() {
    const {className: classBox, value: {attachmentList, comment, sum} = {}, rightMenu} = this.props;
    const {fetchingFiles} = this.state;

    return (
      <div className={cx(styles.box, classBox)}>
        <div className={styles.legalCost}>
          <Label className={styles.label}>Судебные издержки</Label>
          <NumberField onChange={v => this.handlerOnChange({sum: v})} className={styles.legalCostSum} value={sum}/>
          <ButtonIcon style={{marginLeft: '12px'}} onClick={this.handlerEditOnClick} tooltip={"Редактировать комментарий"}><EditIcon className={styles.icon} /></ButtonIcon>
          <ButtonAttachFile
            classIcon={styles.icon}
            onFetching={this.handlerAttachFileButtonOnFetching}
            onFetchingComplete={this.handlerAttachFileButtonOnFetchingComplete}
            onFetchingError={this.handlerAttachFileButtonOnFetchingComplete}
            onChange={this.handlerAttachFileButtonOnChange}
          />
          {rightMenu}
        </div>
        <Label className={styles.comment}>{comment}</Label>
        <AttachFileList
          fetchingFiles={fetchingFiles}
          className={styles.attachFiles}
          files={fromAttachmentList(attachmentList)}
          onChange={v => this.handlerOnChange({attachmentList: toAttachmentList(attachmentList, v)})}
        />
      </div>
    );
  }
}

LegalCost.propTypes = {
  rightMenu: PropTypes.element,
  className: PropTypes.string,
  value: PropTypes.objectOf({
    sum: PropTypes.number,
    attachmentList: PropTypes.arrayOf({
      id: PropTypes.string,
      fileStorageId: PropTypes.string,
      Name: PropTypes.string,
    }),
    comment: PropTypes.string,
  }),
  onChange: PropTypes.func,
};

export default LegalCost;


// WEBPACK FOOTER //
// ./src/components/page/CollectionCaseEditor/ExpansionPanelPenaltyAndLegalCost/LegalCosts/LegalCost/LegalCost.jsx